/**
 * garson-cagir.v2.js — Vitavien Şişli sticky FAB grubu (Garson Çağır + Hesap İste).
 *
 * QR sözleşmesi sabit: `/pages/vitavien-sisli-menu?masa=<slug>` (örn: ?masa=bahce-1).
 * Eski v1 ?table_id=N akışı kaldırıldı; slug → Clopos table_id eşleştirmesini Worker yapıyor (D1 branch_tables).
 *
 * Worker /call_waiter sözleşmesi: { branch, masa_slug, type: "WAITER" | "PAY" }
 */
(function () {
  'use strict';

  var WORKER_URL = 'https://vitavien-api.hakan-42c.workers.dev';
  var BRANCH = 'sisli';
  var COOLDOWN_MS = 60 * 1000;

  function readQueryParam(key) {
    try {
      var p = new URLSearchParams(window.location.search);
      var v = p.get(key);
      return v ? v.trim() : null;
    } catch (_) {
      return null;
    }
  }

  // QR'dan gelen slug (masa veya table_id). v1 ile geri-uyumluluk için ikisini de tarar.
  var masaSlug = (readQueryParam('masa') || readQueryParam('table_id') || '').toLowerCase();
  if (!masaSlug) {
    // QR'dan gelmeyen ziyaretçilere FAB göstermiyoruz (fake çağrı önleme).
    return;
  }

  // SVG ikonları
  var ICON_WAITER =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M12 3a2 2 0 0 1 2 2v.34c2.3.74 4 2.9 4 5.46v3.7l1.7 2.55a1 1 0 0 1-.83 1.55H5.13a1 1 0 0 1-.83-1.55L6 14.5V10.8c0-2.56 1.7-4.72 4-5.46V5a2 2 0 0 1 2-2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M9 18.6a3 3 0 0 0 6 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';
  var ICON_PAY =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="M3 10h18" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="M7 15h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';

  function createButton(type, label, variant, icon) {
    var btn = document.createElement('button');
    btn.className = 'vgc-fab vgc-fab--' + variant;
    btn.type = 'button';
    btn.setAttribute('data-vgc-type', type);
    btn.setAttribute('aria-label', label);
    btn.innerHTML = icon + '<span class="vgc-fab__label">' + label + '</span>';
    return btn;
  }

  var stack = document.createElement('div');
  stack.className = 'vgc-stack is-visible';

  var btnWaiter = createButton('WAITER', 'Garson Çağır', 'primary', ICON_WAITER);
  var btnPay = createButton('PAY', 'Hesap İste', 'secondary', ICON_PAY);

  stack.appendChild(btnPay);
  stack.appendChild(btnWaiter);

  var toast = document.createElement('div');
  toast.className = 'vgc-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');

  document.body.appendChild(stack);
  document.body.appendChild(toast);

  var toastTimer = null;
  function showToast(msg, kind) {
    toast.textContent = msg;
    toast.classList.remove('is-success', 'is-error');
    if (kind === 'success') toast.classList.add('is-success');
    if (kind === 'error') toast.classList.add('is-error');
    toast.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
  }

  function disableButton(btn, defaultLabel, seconds) {
    btn.disabled = true;
    var labelEl = btn.querySelector('.vgc-fab__label');
    var remaining = Math.max(1, Math.round(seconds));

    function tick() {
      if (remaining <= 0) {
        btn.disabled = false;
        if (labelEl) labelEl.textContent = defaultLabel;
        return;
      }
      if (labelEl) labelEl.textContent = 'Yeniden (' + remaining + 'sn)';
      remaining -= 1;
      setTimeout(tick, 1000);
    }
    tick();
  }

  function callWorker(btn, type, defaultLabel) {
    if (btn.disabled) return;
    btn.disabled = true;
    var labelEl = btn.querySelector('.vgc-fab__label');
    if (labelEl) labelEl.textContent = 'İletiliyor…';

    fetch(WORKER_URL + '/call_waiter', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ branch: BRANCH, masa_slug: masaSlug, type: type }),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { status: r.status, body: d };
        });
      })
      .then(function (res) {
        var b = res.body || {};
        if (res.status === 200 && b.ok) {
          showToast(b.message || 'Çağrınız iletildi.', 'success');
          disableButton(btn, defaultLabel, COOLDOWN_MS / 1000);
          return;
        }
        if (res.status === 429) {
          showToast(b.message || 'Çağrınız az önce iletildi.', 'success');
          disableButton(btn, defaultLabel, b.wait_sec || 60);
          return;
        }
        showToast(b.message || 'Çağrı iletilemedi. Lütfen görevliyi işaret ediniz.', 'error');
        if (labelEl) labelEl.textContent = defaultLabel;
        btn.disabled = false;
      })
      .catch(function () {
        showToast('Bağlantı sorunu. Lütfen tekrar deneyiniz.', 'error');
        if (labelEl) labelEl.textContent = defaultLabel;
        btn.disabled = false;
      });
  }

  btnWaiter.addEventListener('click', function () {
    callWorker(btnWaiter, 'WAITER', 'Garson Çağır');
  });
  btnPay.addEventListener('click', function () {
    callWorker(btnPay, 'PAY', 'Hesap İste');
  });
})();
